<template>
  <div class="homeContainer">
    <div class="banner">
      <div class="img-button-container">
        <router-link to="/submit"><img
          src="https://app.brighton.com/design-a-tote/img/final-banner-2.jpg?1"
          alt
          class="bannerImg"
        />
        
        <!-- <button class="img-btn">submit a design</button>-->
        </router-link> 
      </div>
      <!-- <br /> -->
      <!-- <br /> -->
      <div class="staticPopTextWrapper">
        <span class="popButterflyTopLargeText">Here are the current contest entries. Good luck!</span>
        <!-- <span class="popButterflyTopYears">Thank you for sharing your activities with us... you are in our hearts!</span> -->
        <br />
        <div id="SocialBar" class="clearfix">
          <div class="flexer2 search-image clearfix">
            <input
              v-model="searchTerm"
              class="tc_input flexed Put mi_footer_enter_location input_field"
              name="search_image"
              type="text"
              value
              placeholder="Search names..."
            />
            <span>
              <input
                type="submit"
                class="tc_btn modern_button mb_go"
                value="Go"
                @click="searchSubmission"
              />
            </span>
          </div>
          <div id="SocialButtons">
            <span class="social-bottom">
              <a
                target="_blank"
                href="https://www.facebook.com/sharer/sharer.php?u=https://app.brighton.com/brighton-your-day"
              >
                <span class="fa-stack">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-facebook fa-stack-1x fa-inverse"></i>
                </span>
              </a>
              <a
                target="_blank"
                href="https://twitter.com/intent/tweet?text=Share%20your%20social-distancing%20photos%20and%20activities%20with%20us.%0A%23brightonyourday"
              >
                <span class="fa-stack">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-twitter fa-stack-1x fa-inverse"></i>
                </span>
              </a>
              <a
                target="_blank"
                href="https://pinterest.com/pin/create/button/?url=https://app.brighton.com/brighton-your-day&media=https://www.brighton.com/content/SocialShare-BrightonYourDay.jpg&description=Share%20your%20social-distancing%20photos%20and%20activities%20with%20us.%0A%23brightonyourday"
              >
                <span class="fa-stack">
                  <i class="fa fa-circle fa-stack-2x"></i>
                  <i class="fa fa-pinterest-p fa-stack-1x fa-inverse"></i>
                </span>
              </a>
            </span>
          </div>
        </div>
        <!-- <hr style=""> -->
        <br />
        <br />
        <!-- <p class="disclaimer-text">*PHOTO RELEASE:
        I consent to the unrestricted use by <strong>Brighton Collectibles Inc.</strong> and his/her/its successors, assigns, and designees, and those acting with his/her/its permission and authority of any and all photographic or other images (“Images”) of me that <strong>Brighton Collectibles Inc.</strong> creates/created or makes/made from Summer of Joy sweepstakes for all purposes, in any form, and in any and all media, including, without limitation, advertising, solicitation, stock photography, or trade, to copyright same in <strong>Brighton Collectibles Inc.</strong>’s own name or any other name that he/she/it may choose, and the right to use my name in connection therewith if <strong>Brighton Collectibles Inc.</strong> so chooses. 
        </p>-->
      </div>
    </div>
    <!--// banner-->
    <div>
      <div v-if="loading" class="loading">
        <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
        <span>Loading...</span>
      </div>
      <submissionPopup :submission="submissionToShow" v-if="showModal" @cancel="dismissModal()" />
      <div
        class="masonrymain"
        v-masonry
        origin-left="false"
        transition-duration="0.3s"
        item-selector=".item"
        horizontal-order="true"
        fit-width="true"
      >
        <div
          v-if="filteredSubmissions != null"
          v-masonry-tile
          class="item"
          v-for="(submission, index) in filteredSubmissions"
        >
          <div class="mask"></div>
          <div class="post">
            <a href="javascript:void(0)" @click="showSubmission(submission, $event)">
              <img
                v-if="submission.userImage != ''"
                :src="'https://app.brighton.com/brighton-your-day/tmp/340_' + submission.userImage"
                alt="#brightonyourday"
              />
              <!-- <img
                v-else
                src="https://app.brighton.com/power-of-pink/heart_icon2.png"
                alt="#brightonyourday"
              /> -->
            </a>
            <p class="text">
              <span
                class="text1"
              >{{submission.firstName}} {{submission.lastName.substring(0, 1).toUpperCase()}}.</span>
              <span>
                <div v-if="submission.city != ''">
                {{submission.city}}</div>
              </span>
              <span
                class="textCollpased"
                @click="toggleTextExpansion(submission)"
                v-show="submission.pictureLocation.length > 25 && submission.expand == false"
              >
                {{submission.pictureLocation.substring(0, 25)}}
                <strong>
                  ...
                  <span>expand</span>
                </strong>
              </span>
              <span
                class="textCollpased"
                @click="toggleTextExpansion(submission)"
                v-show="submission.pictureLocation.length > 25 && submission.expand == true"
              >{{submission.pictureLocation}}</span>
              <span
                v-show="submission.pictureLocation.length <= 25"
                class
              >{{submission.pictureLocation}}</span>
            </p>
          </div>
        </div>
      </div>
      <button v-show="morePicAvailable" @click="loadMorePic" class="loadMoreBtn">
        <span v-if="!loadingMore">Load More</span>
        <span v-else>Loading...</span>
      </button>
      <span
        class="noResultText"
        v-if="filteredSubmissions != null && filteredSubmissions.length == 0 && !loading"
      >Nothing is found</span>
    </div>
  </div>
</template>

<script>
import submissionPopup from "@/components/SubmissionPopup";

const axios = require("axios");
export default {
  props: {},
  data() {
    return {
      loading: true,
      loadingMore: false,
      submissions: null,
      showModal: false,
      searchTerm: "",
      filteredSubmissions: null,
      morePicAvailable: false
    };
  },
  components: {
    submissionPopup
  },
  mounted() {
    this.getAllSubmissions(() => {
      this.loading = false;

      // show specific submission
      if (!isNaN(this.$route.params.id)) {
        let index = this.submissions.findIndex(element => {
          return element.id == this.$route.params.id;
        });
        if (index !== -1) {
          this.showSubmission(this.submissions[index], null);
        }
      }
    });
  },
  watch: {
    $route: function(refreshPage) {
      console.log("detected changes", refreshPage);
      if (refreshPage.fullPath == "/") this.showModal = false;
    }
  },
  computed: {},
  methods: {
    async searchSubmission() {
      // this.filteredSubmissions = this.submissions.filter(submission=>{
      //   return (submission.firstName.trim().toLowerCase() + ' ' + submission.lastName.trim().toLowerCase()).indexOf(this.searchTerm.trim().toLowerCase()) != -1
      // })
      // this.$forceUpdate()
      // this.$nextTick(()=>{
      //   this.$redrawVueMasonry()
      // })

      this.loading = true;
      this.morePicAvailable = false;

      this.filteredSubmissions = null;
      this.submissions = null;

      // display all if nothing is being searched
      if (this.searchTerm.trim() == "") {
        this.filteredSubmissions = null;
        this.getAllSubmissions(() => {
          this.loading = false;
        });
      } else {
        // this.filteredSubmissions = null
        var formData = new FormData();
        formData.append("searchTerm", this.searchTerm.trim().toLowerCase());
        let url = `https://app.brighton.com/brighton-your-day/api/`;
        let returnedData = await axios({
          method: "POST",
          url: url,
          data: formData,
          responseType: "json",
          config: {
            headers: { "Content-Type": "application/x-www-form-urlencoded" }
          }
        });
        if (returnedData.data.success) {
          this.submissions = returnedData.data.submissions;
          this.filteredSubmissions = returnedData.data.submissions.slice(0);
          this.filteredSubmissions.map(
            submission => (submission.expand = false)
          );

          // this.$forceUpdate()
          // this.$nextTick(()=>{
          //   this.$redrawVueMasonry()
          // })

          this.loading = false;
        }
      }
    },
    async loadMorePic() {
      this.loadingMore = true;
      var formData = new FormData();
      formData.append(
        "lastSubmissionID",
        this.submissions[this.submissions.length - 1].id
      );
      let url = `https://app.brighton.com/brighton-your-day/api/`;
      let returnedData = await axios({
        method: "POST",
        url: url,
        data: formData,
        responseType: "json",
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        }
      });
      if (returnedData.data.success) {
        this.morePicAvailable =
          returnedData.data.submissions.length == 125 ? true : false;
        this.submissions = this.submissions.concat(
          returnedData.data.submissions
        );
        let tempFilteredSubmissions = returnedData.data.submissions.slice(0);
        tempFilteredSubmissions.map(submission => (submission.expand = false));
        this.filteredSubmissions = this.filteredSubmissions.concat(
          tempFilteredSubmissions
        );
        this.loadingMore = false;
        // let minElement = this.submissions.reduce((accumulator, currentValue)=>{
        //   return accumulator.id > currentValue.id ? currentValue : accumulator
        // })
      }
    },
    dismissModal() {
      this.showModal = false;
      this.$router.push("/");
    },
    showSubmission(submission, e) {
      if (e != null) e.preventDefault();

      this.submissionToShow = submission;
      this.showModal = true;
      this.$router.push("/submission/" + submission.id);
    },
    toggleTextExpansion(submission) {
      if (submission.pictureLocation.length > 25) {
        submission.expand = !submission.expand;
        this.$forceUpdate();
        this.$nextTick(() => {
          this.$redrawVueMasonry();
        });
      }
    },
    async getAllSubmissions(callBack) {
      var formData = new FormData();
      let url =
        `https://app.brighton.com/brighton-your-day/api/` +
        (this.$route.path == "/dev" ? "dev" : "");
      let returnedData = await axios({
        method: "POST",
        url: url,
        responseType: "json",
        config: {
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        }
        // onUploadProgress: function (e) {
        //     if (e.lengthComputable) {
        //         console.log("e.loaded: %o, e.total: %o, percent: %o", e.loaded, e.total, (e.loaded / e.total ) * 100);
        //     }
        // },
      });
      if (returnedData.data.success) {
        this.submissions = returnedData.data.submissions;
        this.filteredSubmissions = returnedData.data.submissions;
        this.submissions.map(submission => (submission.expand = false));
        this.filteredSubmissions.map(submission => (submission.expand = false));
        this.morePicAvailable =
          returnedData.data.submissions.length == 125 ? true : false;

        // let minElement = this.submissions.reduce((accumulator, currentValue)=>{
        //   return accumulator.id > currentValue.id ? currentValue : accumulator
        // })
        // console.log(minElement)
        callBack();
      }
    }
  }
};
</script>

<style lang="scss">
.homeContainer {
  /* max-width:90%; */
  margin: 0 auto;
  min-height: 54vh;
  display: block;
  justify-content: center;
  align-items: center;
  text-align: center;
  .loading {
    i {
      /* color: */
    }
    span {
      display: block;
      font-size: 20px;
      font-weight: bold;
      margin-top: 10px;
    }
  }
  .item {
    padding: 10px;
    text-align: left;
    box-sizing: border-box;
    position: relative;

    .mask {
      cursor: pointer;
      top: 0;
      left: 0;
      width: 100%;
      height: 90%;
      z-index: 0;
      padding-bottom: 0px;
      opacity: 0;
      position: absolute;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 5px;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
    }
    .post {
      width: 214px;
      // width:330px;
      position: relative;

      .text {
        max-width: 100%;
        display: block;
        padding: 5px;
        margin: 0;
        span {
          display: block;
          line-height: 1.3;
          font-size: 12px;
          color: #ggg;
          word-break: break-word;
        }
        span.text1 {
          line-height: 1.5;
          font-weight: bold;
        }
        span.textCollpased {
          cursor: pointer;
          span {
            display: inline-block;
            font-size: 11px;
            text-decoration: underline;
          }
        }
      }
      a {
        cursor: pointer;
        line-height:1;
        display:inline-block;
        img {
          width:100%;
          border-radius: 5px;
          max-width: 100%;
          line-height:1;
          // background: rgba(255, 210, 192, 0.6);
          cursor: zoom-in;
          /* padding: 10px; */
          /* box-sizing: border-box; */
        }
      }
    }
  }

  .submissions {
    .submission {
      img {
        display: block;
        max-width: 100%;
      }
    }
  }
}

/* .homeContainer .item .post:hover .mask, */
.homeContainer .item:hover .mask {
  opacity: 0.3;
  /* padding-bottom:25px; */
  height: 100%;
}

.homeContainer {
  .banner {
    .staticPopTextWrapper {
      margin-top: 2em;
    }
    .popButterflyTopLargeText {
      display: block;
      text-align: center;
      text-transform: uppercase;
      font-size: 1.3em;
      /*		line-height: 0em;*/
      margin-top: 1em;
      /*		margin-bottom: .5em;*/
      font-family: "Lato";
      font-weight: 600;
      letter-spacing: 0.1em;
      color: #1d3a5c;
    }
    .popButterflyTopYears {
      display: block;
      text-align: center;
      font-size: 1.5em;
      margin-bottom: 0.5em;
      font-family: "Lato";
      font-weight: 600;
      letter-spacing: 0.08em;
      color: #1d3a5c;
    }
    .popButterflyTopRecognition {
      display: block;
      text-align: center;
      font-size: 1.5em;
      margin-bottom: 0.5em;
      font-family: "Lato";
      font-weight: 300;
      letter-spacing: 0em;
      color: black;
    }

    .disclaimer-text {
      display: block;
      text-align: center;
      font-size: 12px;
      margin: 0 5px;
      font-family: "Lato", Arial, Helvetica, sans-serif;
      color: #000000;
      line-height: 1.4 !important;
    }

    .img-button-container {
      position: relative;
      width: 100%;
    }

    .bannerImg {
      width: 100%;
      height: auto;
    }

    .img-btn {
      position: absolute;
      top: 96%;
      border:0;
      left: 50%;
      transform: translate(-50%, 0%);
      -ms-transform: translate(-50%, 0%);
      display: inline-block;
      padding: 14px 54px;
      line-height: 1.2em;
      color: #fff;
      background: black;
      font-weight: 600;
      font-size: 16px;
      text-transform: uppercase;
      letter-spacing: 0.3em;
      min-width: 280px;
    }
    #SocialBar {
      padding: 0 20px;
    }

    #SocialButtons {
      float: right;
      margin-top: 10px;
      display:none;
    }
    .clearfix::after {
      content: "";
      clear: both;
      display: table;
    }
    .search-image {
      width: 300px !important;
      float: left;
    }
    .tc_btn {
      height: 40px !important;
    }

    /*	media query*/
    @media (max-width: 800px) {
      .popButterflyTopLargeText {
        font-size: 1em;
      }
      .popButterflyTopYears {
        font-size: 0.8em;
      }
      .popButterflyTopRecognition {
        font-size: 1.5em;
        padding: 0 20px;
      }
      .img-btn {
        font-size: 12px;
      }
    }
  }
}
button.loadMoreBtn {
  color: black;
  background-color: white;
  cursor: pointer;
  border: 1px solid #000;
  text-transform: uppercase;
  font-size: 18px;
  margin: 30px 0;
  padding: 10px 30px;
}
button.loadMoreBtn:hover {
  background: black;
  color: white;
}
.noResultText {
  display: inline-block;
  font-size: 20px;
  text-transform: uppercase;
  padding: 10px 20px;
  border: 1px solid #000;
}



@media (max-width: 478px) {
  .masonrymain{
    margin: 0 auto;
    // width:100% !important;
  }
}

@media (max-width: 380px) {
  .masonrymain{
    margin: 0 auto;
    width:100% !important;
  }
  .homeContainer .item,
  .homeContainer .item .post,
  .homeContainer .item .post img{
    width:100%;
  }

  .modal-body .submission{
    padding:0 !important;
  }
}
</style>
